import validate from "/tmp/tmpkyj7iuwo/node_modules/nuxt/dist/pages/runtime/validate.js";
import gtag_45global from "/tmp/tmpkyj7iuwo/middleware/gtag.global.ts";
import legacy_45redirect_45global from "/tmp/tmpkyj7iuwo/middleware/legacyRedirect.global.ts";
import redirect_45global from "/tmp/tmpkyj7iuwo/middleware/redirect.global.ts";
import manifest_45route_45rule from "/tmp/tmpkyj7iuwo/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  gtag_45global,
  legacy_45redirect_45global,
  redirect_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}